/* eslint-disable */
import actions from "./actions";
export default function runDefaultActions(dispatch, persistenceStore) {
  if (!!persistenceStore.get('authorizationToken')) {
    dispatch(actions.authentication.setLoginStatus(true));
  }
}